import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { SecondaryButtonStyled } from '~/styles';

export const ToolCatalogsContainer = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  p: { sm: '500' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    width: 99%;
    height: 95%;
    border-radius: 4px;
  `}
`;

export const FileUploadContainer = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  gap: { sm: '200' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    width: 90%;
  `}
`;

export const ToolCatalogsBoxStyled = styled(Box).attrs({
  alignSelf: { sm: 'cernter' },
  justifyContent: { sm: 'space-around' },
  alignItems: { sm: 'center' },
  flexDirection: { sm: 'column' },
  p: { sm: '400' },
})`
  width: 100%;
  height: 92vh;
`;

export const FooterStyled = styled(Box).attrs({
  px: { sm: '500' },
  py: { sm: '400' },
  justifyContent: { sm: 'space-between' },
  gap: { sm: '500' },
})`
  width: 99%;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.componentStyles.boxShadowInverted};
`;

export const CancelButtonStyled = styled(SecondaryButtonStyled)`
  ${({ theme }) => css`
    border-color: ${theme.colors.blue[400]};
    padding: ${theme.spacings[400]} ${theme.spacings[600]};
  `}
`;
